@for(kommentar of kommentarer(); track kommentar.id){
  <kommentar-traad [traad]="kommentar"/>
}
